import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

/**
 * iconPark图标引入模板
 *  - 使用时无需关注这里的参数，这里只需替换<svg></svg>部分并修改组件名称即可
 *  - 在页面引入图标见GrowpIcon组件
 *
 * @param param - 参数
 * @param param._width - 宽度
 * @param param._height - 高度
 * @param param._fill - 填充色
 * @param param.className - className
 * @param param.spin - 是否旋转
 * @param param.rtl - 是否左右旋转
 * @param param.rest - 其他参数
 *
 * @returns React.ReactNode
 */
export const Menus = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="M10.036 6h-.072A2.939 2.939 0 0 0 7 8.964v.072A2.939 2.939 0 0 0 9.964 12h.072A2.939 2.939 0 0 0 13 9.036v-.072A2.939 2.939 0 0 0 10.036 6m0 15h-.072A2.939 2.939 0 0 0 7 23.964v.072A2.939 2.939 0 0 0 9.964 27h.072A2.939 2.939 0 0 0 13 24.036v-.072A2.939 2.939 0 0 0 10.036 21m0 15h-.072A2.939 2.939 0 0 0 7 38.964v.072A2.939 2.939 0 0 0 9.964 42h.072A2.939 2.939 0 0 0 13 39.036v-.072A2.939 2.939 0 0 0 10.036 36M23.964 6h.072A2.939 2.939 0 0 1 27 8.964v.072A2.939 2.939 0 0 1 24.036 12h-.072A2.939 2.939 0 0 1 21 9.036v-.072A2.939 2.939 0 0 1 23.964 6m0 15h.072A2.939 2.939 0 0 1 27 23.964v.072A2.939 2.939 0 0 1 24.036 27h-.072A2.939 2.939 0 0 1 21 24.036v-.072A2.939 2.939 0 0 1 23.964 21m0 15h.072A2.939 2.939 0 0 1 27 38.964v.072A2.939 2.939 0 0 1 24.036 42h-.072A2.939 2.939 0 0 1 21 39.036v-.072A2.939 2.939 0 0 1 23.964 36m14-30h.072A2.939 2.939 0 0 1 41 8.964v.072A2.939 2.939 0 0 1 38.036 12h-.072A2.939 2.939 0 0 1 35 9.036v-.072A2.939 2.939 0 0 1 37.964 6m0 15h.072A2.939 2.939 0 0 1 41 23.964v.072A2.939 2.939 0 0 1 38.036 27h-.072A2.939 2.939 0 0 1 35 24.036v-.072A2.939 2.939 0 0 1 37.964 21m0 15h.072A2.939 2.939 0 0 1 41 38.964v.072A2.939 2.939 0 0 1 38.036 42h-.072A2.939 2.939 0 0 1 35 39.036v-.072A2.939 2.939 0 0 1 37.964 36"
            style={{ mixBlendMode: 'passthrough' }}
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
